import ShowAll from "../components/Search/ShowAll/ShowAll";
import TopSection from "../components/Search/TopSection/TopSection";

export default function Search({ cart, setCart, showMessage, setShowMessage }) {
  return (
    <>
      <TopSection></TopSection>
      <ShowAll
        cart={cart}
        setCart={setCart}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
      />
    </>
  );
}
